import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getEliterature, updateEliterature } from '../../utils/api.js';
import { Button, Card, Checkbox, Col, Row } from 'antd';

const EliteratureSelector = ({ organizationId, onChange }) => {
	const [eliterature, setEliterature] = useState([]);
	const [selected, setSelected] = useState([]);

	useEffect(() => {
		const loadEliterature = async () => {
			if (eliterature.length === 0) {
				const result = (await getEliterature(organizationId)) || [];

				const availableItems = result.eliterature.entries.map((book) => ({
					label: book.title,
					id: book.id,
				}));

				const selectedItems = result.eliterature.entries
					.filter((book) => book.access)
					.map((book) => book.id);

				setEliterature(availableItems);
				setSelected(selectedItems);
			}
		};

		loadEliterature();
	}, []);

	const handleChange = async (values) => {
		setSelected(values);
		await updateEliterature(organizationId, values);
	};

	const selectAll = async () => {
		const allIds = eliterature.map((book) => book.id);
		setSelected(allIds);
		await updateEliterature(organizationId, allIds);
	};

	return (
		<div>
			<Row style={{ padding: '18px 0' }}>
				<Col span={12}>
					<h2>E-litteratur</h2>
				</Col>
				<Col span={12}>
					<Button.Group style={{ float: 'right' }}>
						<Button
							type='primary'
							size='default'
							onClick={selectAll}
							disabled={eliterature.length === selected.length}
						>
							Välj alla
						</Button>
						<Button
							type='default'
							size='default'
							onClick={() => handleChange([])}
							disabled={selected.length == 0}
						>
							Rensa
						</Button>
					</Button.Group>
				</Col>
			</Row>
			<Card>
				<Checkbox.Group style={{ width: '100%' }} onChange={handleChange} value={selected}>
					{eliterature.map((book) => (
						<Col xxl={8} xl={12} lg={24} md={24} sm={24} key={book.id}>
							<Checkbox value={book.id}>{book.label}</Checkbox>
						</Col>
					))}
				</Checkbox.Group>
			</Card>
		</div>
	);
};

EliteratureSelector.propTypes = {
	organizationId: PropTypes.number.isRequired,
	onChange: PropTypes.func,
};

export default EliteratureSelector;



// WEBPACK FOOTER //
// ./src/components/eliterature/eliteratureSelector.jsx